
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/[slug]",
      function () {
        return require("private-next-pages/magazine/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/[slug]"])
      });
    }
  